export const ERR_OK = 0
export const ERR_SUCCESS = 2000

// export const baseURL = ''

// 打包发布前需要设置这个
export const baseURL = '//api.ke.video'
